import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestReceiptComponent } from './request-receipt.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RequestReceiptModalService } from './request-receipt.service';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [RequestReceiptComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    PhoneNumberModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
  ],
  providers:[RequestReceiptModalService],
  exports: [RequestReceiptComponent],
  entryComponents: [RequestReceiptComponent],
})
export class RequestReceiptModule { }
